export const NAV_DEF = new Map(
  [
    {
      name: 'Employers',
      sections: [
        {
          name: 'Why Choose Evry',
          description:
            'We deliver health insurance that helps ensure the people that we serve live healthier and happier lives.',
          link: '/why-choose-evry',
          icon: '/briefcase.svg',
          target: '_self',
        },
        {
          name: 'How We Do It',
          description:
            'Built for the modern business and the mobile workforce.',
          link: '/how-we-do-it',
          icon: '/two-people.svg',
          target: '_self',
        },
        {
          name: 'How We Compare',
          description:
            "We created the health insurance that we've always wanted to have.",
          link: '/how-we-compare',
          icon: '/compare-icon.svg',
          target: '_self',
        },
      ],
      related: {
        type: 'image',
        media: '/work-colleagues-discussing-business-together.png',
        title: 'Meet Your New Team',
        description:
          'You’ll be a member too! See why Evry really is a different brand of health insurance.',
        link: '/meet-your-new-team',
        button: 'Learn More',
      },
    },
    {
      name: 'Members',
      sections: [
        {
          name: 'Find a Provider',
          description: 'Build a great relationship with a local physician.',
          link: 'https://providers.evryhealth.com/',
          icon: '/folders-icon.svg',
          target: '_blank',
        },
        {
          name: 'Look Up Prescriptions',
          description: 'Easily find covered medications.',
          link: 'https://prime.adaptiverx.com/webSearch/index?key=cnhmbGV4LnBsYW4uUGxhblBkZlR5cGUtODA5',
          icon: '/briefcase.svg',
          target: '_blank',
        },
        {
          name: 'Find a Pharmacy',
          description: 'Find a pharmacy near you.',
          link: 'https://web.primetherapeutics.com/member/find-a-pharmacy',
          icon: '/pharmacy.svg',
          target: '_blank',
        },
        {
          name: 'Meet Your New Team',
          description:
            "With Evry, you'll be paired with your own team of nurses, nutritionists, and doctors who work for you.",
          link: '/meet-your-new-team',
          icon: '/stethescope.svg',
          target: '_self',
        },
        {
          name: 'Download the Evry mobile app',
          description: 'All the features you expect.',
          link: '/mobileapp',
          icon: '/download-icon-blue.svg',
          target: '_self',
        },
        {
          name: 'Virtual Care',
          description:
            'Talk to a board-certified physician 24/7 for $0. Available on-demand by phone and video.',
          link: '/virtual-care',
          icon: '/mobile-phone-icon.svg',
          target: '_self',
        },
        {
          name: 'Forms and Notices',
          description: 'Download any forms you need.',
          link: '/forms?type=Members',
          icon: '/search-shield-icon.svg',
          target: '_self',
        },
        {
          name: 'Request Provider Addition',
          description: 'Request a provider to be added to the Evry network.',
          link: '/request-provider-addition',
          icon: '/radio-checkmark.svg',
          target: '_self',
        },
      ],
      related: {
        type: 'image',
        media: '/work-colleagues-discussing-business-together-during-work.png',
        title: 'Questions?',
        description:
          'Our team is here to answer any questions you may have about your plan.',
        link: '/contact-us',
        button: 'Contact Us',
      },
    },
    {
      name: 'Providers',
      sections: [
        {
          name: 'Prior Authorization',
          description: 'See which procedures need prior authorization.',
          link: '/prior-authorization',
          icon: '/key-icon.svg',
          target: '_self',
        },
        {
          name: 'Notifications and Admissions',
          description:
            'Inpatient admission notification helps to get your claims paid correctly and on time.',
          link: '/admission-notification',
          icon: '/notification-icon.svg',
          target: '_self',
        },
        {
          name: 'Request to Join the Evry Network',
          description: 'Faster payments. No games.',
          link: '/join-the-evry-network',
          icon: '/radio-checkmark.svg',
          target: '_self',
        },
        {
          name: 'Retrospective Reviews',
          description: 'Determining coverage after treatment has been given.',
          link: '/retrospective-reviews',
          icon: '/pages-icon.svg',
          target: '_self',
        },
        {
          name: 'Clinical Practice Guidelines',
          description: 'Evidence-based clinical practice guidelines and resources.',
          link: '/clinical-practice-guidelines',
          icon: '/pages-icon.svg',
          target: '_self',
        },
        {
          name: 'Eligibility Verification',
          description:
            'Verify a member’s current insurance eligibility and in-network status in real time.',
          link: '/eligibility-verification',
          icon: '/shield-check-icon.svg',
          target: '_self',
        },
        {
          name: 'Claims Verification',
          description:
            'Check the status of a submitted claim and view the explanation of payment in real time.',
          link: '/claims-verification',
          icon: '/shield-check-icon.svg',
          target: '_self',
        },
        {
          name: 'Prior Authorization Status',
          description:
            'Check the prior authorizations on file for a member that your NPI appears on.',
          link: '/prior-auth-status',
          icon: '/shield-check-icon.svg',
          target: '_self',
        },
        {
          name: 'Forms and Notices',
          description: 'Download any forms you need.',
          link: '/forms?type=Providers',
          icon: '/search-shield-icon.svg',
          target: '_self',
        },
        // {
        //   name: 'Policies',
        //   description:
        //     'Learn about our policies on claims processing, coverage details and more.',
        //   link: '/policies',
        //   icon: '/shield-check-icon.svg',
        //   target: '_self',
        // },
      ],
      related: {
        type: 'image',
        media: '/doctorsOffice.webp',
        title: 'Virtual Care',
        description: 'Our virtual care program will make your job easier too.',
        link: '/contact-us',
        button: 'Contact Us',
      },
    },
    {
      name: 'Verification',
      sections: [
        {
          name: 'Eligibility Verification',
          description:
            'Verify a member’s current insurance eligibility and in-network status in real time.',
          link: '/eligibility-verification',
          icon: '/shield-check-icon.svg',
          target: '_self',
        },
        {
          name: 'Claims Verification',
          description:
            'Check the status of a submitted claim and view the explanation of payment in real time.',
          link: '/claims-verification',
          icon: '/shield-check-icon.svg',
          target: '_self',
        },
        {
          name: 'Prior Authorization Status',
          description:
            'Check the prior authorizations on file for a member that your NPI appears on.',
          link: '/prior-auth-status',
          icon: '/shield-check-icon.svg',
          target: '_self',
        },
      ],
      related: {
        type: 'image',
        media: '/lady-on-laptop-video-calling.png',
        title: 'Questions?',
        description:
          'Our team is here to answer any questions you may have about verifying eligibility, claims, or prior authorization.',
        link: '/contact-us',
        button: 'Contact Us',
      },
    },
    {
      name: 'About',
      sections: [
        {
          name: 'Our Story',
          description:
            "We're on a mission. A mission to build the health insurance company we've always wanted for ourselves.",
          link: '/our-story',
          icon: '/pages-icon.svg',
          target: '_self',
        },
        {
          name: 'Careers',
          description: "We're making health insurance work again. Join us.",
          link: '/careers',
          icon: '/person-plus.svg',
          target: '_self',
        },
        {
          name: 'News',
          description: 'In the news.',
          link: '/news',
          icon: '/news.svg',
          target: '_self',
        },
        // {
        //   name: 'Blog',
        //   description:
        //     'See our quarterly updates for providers and health plan update.',
        //   link: '/blog',
        //   icon: '/blog.svg',
        //   target: '_self',
        // },
      ],
      related: {
        type: 'image',
        media: '/people-having-a-meeting.png',
        title: 'Get in Touch',
        description:
          "We're here to answer any questions you have about our revolutionary health insurance plans.",
        link: '/contact-us',
        button: 'Contact Us',
      },
    },
  ].map(x => [x.name, x])
)
